// Despachos alert: a sale's remisiones, added up, must carry exactly the sale's Cajas (the server's
// check is dispatch-referrals/box-mismatches/). Works on the remisiones list (each with sale_detail).
export function remisionBoxMismatches(remisiones) {
  const bySale = new Map();
  remisiones.forEach((r) => {
    const entry = bySale.get(r.sale) || { sale: r.sale, sale_boxes: r.sale_detail?.boxes ?? 0, remision_boxes: 0, remisiones: [] };
    entry.remision_boxes += r.boxes || 0;
    entry.remisiones.push(r.id);
    bySale.set(r.sale, entry);
  });
  return new Map([...bySale].filter(([, e]) => e.remision_boxes !== e.sale_boxes)
    .map(([sale, e]) => [sale, { ...e, difference: e.remision_boxes - e.sale_boxes }]));
}

// Fired (on window) after remisiones change, so the Despachos badge updates right away.
export const REMISIONES_CHANGED_EVENT = 'farmershub:remisiones-changed';

export const fmtBoxes = (n) => Number(n).toLocaleString('es-EC');
